import styled from "styled-components";
import NavBar from "../../components/NavBar";
import { getLastNotice } from "../../api";
import { useState, useEffect } from "react";
import { Empty } from "antd-mobile";
import { RightOutline } from "antd-mobile-icons";
import useGlobal from "../../hooks/useGlobal";
import NoticeDetail from './detail'
import { useIntl } from "react-intl";
import useCommon from "../../hooks/Common/useCommon";
import { useRef } from "react";
export default function Notice() {
  const [list, setList] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [info, setInfo] = useState({});
  const {showLoading, closeLoading} = useGlobal();
  const loading = useRef()
  useEffect(() => {
    loadList();
  }, []);
  const intl = useIntl()
  const {lang} = useCommon()
  const loadList = async () => {
    showLoading(intl.formatMessage({id:'common.loading',defaultMessage:'加載中...'}),loading);
    const res = await getLastNotice({
      lang: lang === 'en' ? 'en' : 'cn',
    });
    closeLoading(loading)
    console.log("notice", res);
    setList(res.data.list);
  };
  return (
    <>
      {showDetail ? <>
        <NavBar title={intl.formatMessage({id:'pages.notice.detail',defaultMessage:'公告详情'})} showLeft onClick={()=> {
          setShowDetail(false)
        }} />
        <NoticeDetail info={info}/>
        </> :<>
      <NavBar title={intl.formatMessage({id:'pages.notice',defaultMessage:'公告'})} showLeft />
      <Wrapper>
        {list.map((e) => (
          <NLine key={e.id} onClick={() => {
            setShowDetail(true)
            setInfo(e)
          }}>
            <div>
              <div className="title">{e.title}</div>
              <div className="time">{e.create_time.split(" ")[0]}</div>
            </div>
            <div>
              <RightOutline className="icon" />
            </div>
          </NLine>
        ))}
        {!list || !list.length ? <Empty description={ intl.formatMessage({id:'common.no_data',defaultMessage:'暫無數據'})} /> : null}
      </Wrapper>
      </>}
    </>
  );
}

const Wrapper = styled.div`
  padding: 0 1.3rem;
`;
const NLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0;
  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.0rem;

    color: #000000;
  }
  .time {
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #8b8b8b;
    margin-top: 1.0rem;
  }
  .icon {
    color: #000000;
    font-size: 1.8rem;
    font-weight: 800;
  }
`;
